import React from 'react';
import classNames from 'classnames';
import styles from '../../../../styles/views/plans/PlanVersionPreview.scss';
import Tooltip from '../../../../components/Tooltip';
import { __ } from '../../../../core/utils';

const Button = ({
  id,
  icon: Icon,
  onClick,
  extraClass,
  active,
  onDoubleClick,
  seeMore,
  label,
}) => (
  <Tooltip
    placement='left'
    text={
      <span
        className={styles.thumbPreview}
        style={{
          width: seeMore ? '200px' : 'unset',
          display: 'flex',
        }}
      >
        {!seeMore ? label : `${label}\n${__('Click to see more options')}`}
      </span>
    }
    html={true}
    dark={true}
  >
    <div
      key={id}
      className={classNames(
        styles.icon,
        extraClass && extraClass.map((cls) => styles[cls]),
        active && styles.active
      )}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <Icon />
    </div>
  </Tooltip>
);

export default Button;
